module.exports = __webpack_public_path__ + "media/images/area/area_saitamaM400-61ee48efe3893f85d3bc0efcc3fac3b1.jpg";